import { call, put, takeEvery, takeLatest, all } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_PRESCRIBERS = 'FETCH_PRESCRIBERS';
export const FETCH_PRESCRIBERS_SUCCESS = 'FETCH_PRESCRIBERS_SUCCESS';
export const FETCH_PRESCRIBERS_FAIL = 'FETCH_PRESCRIBERS_FAIL';
export const CLEAR_PRESCRIBERS = 'CLEAR_PRESCRIBERS';
export const CREATE_PRESCRIBER = 'CREATE_PRESCRIBER';
export const CREATE_PRESCRIBER_SUCCESS = 'CREATE_PRESCRIBER_SUCCESS';
export const CREATE_PRESCRIBER_FAIL = 'CREATE_PRESCRIBER_FAIL';
export const UPDATE_PRESCRIBER = 'UPDATE_PRESCRIBER';
export const UPDATE_PRESCRIBER_SUCCESS = 'UPDATE_PRESCRIBER_SUCCESS';
export const UPDATE_PRESCRIBER_FAIL = 'UPDATE_PRESCRIBER_FAIL';
export const DELETE_PRESCRIBER = 'DELETE_PRESCRIBER';
export const DELETE_PRESCRIBER_SUCCESS = 'DELETE_PRESCRIBER_SUCCESS';
export const DELETE_PRESCRIBER_FAIL = 'DELETE_PRESCRIBER_FAIL';
export const ADD_PRESCRIBER_RESOURCE = 'ADD_PRESCRIBER_RESOURCE';
export const ADD_PRESCRIBER_RESOURCE_SUCCESS = 'ADD_PRESCRIBER_RESOURCE_SUCCESS';
export const ADD_PRESCRIBER_RESOURCE_FAIL = 'ADD_PRESCRIBER_RESOURCE_FAIL';
export const REMOVE_PRESCRIBER_RESOURCE = 'REMOVE_PRESCRIBER_RESOURCE';
export const REMOVE_PRESCRIBER_RESOURCE_SUCCESS = 'REMOVE_PRESCRIBER_RESOURCE_SUCCESS';
export const REMOVE_PRESCRIBER_RESOURCE_FAIL = 'REMOVE_PRESCRIBER_RESOURCE_FAIL';

// Reducer
export default function prescribersReducer(state = { data: [], count: 0, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_PRESCRIBERS:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_PRESCRIBERS_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_PRESCRIBERS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_PRESCRIBERS:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case CREATE_PRESCRIBER_SUCCESS: {
      const newData = [
        ...state.data.slice(0, state.data.length),
        payload,
      ];
      return {
        ...state,
        count: state.count + 1,
        data: newData,
      };
    }
    case UPDATE_PRESCRIBER_SUCCESS:
    case ADD_PRESCRIBER_RESOURCE_SUCCESS:
    case REMOVE_PRESCRIBER_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PRESCRIBER_SUCCESS: {
      const index = state.data.findIndex(dataItem => dataItem.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchPrescribers(payload) {
  return { type: FETCH_PRESCRIBERS, payload };
}

export function fetchPrescribersSuccess(payload) {
  return { type: FETCH_PRESCRIBERS_SUCCESS, payload };
}

export function fetchPrescribersFail(payload) {
  return { type: FETCH_PRESCRIBERS_FAIL, payload };
}

export function clearPrescribers(payload) {
  return { type: CLEAR_PRESCRIBERS, payload };
}

export function createPrescriber(payload) {
  return { type: CREATE_PRESCRIBER, payload };
}

export function createPrescriberSuccess(payload) {
  return { type: CREATE_PRESCRIBER_SUCCESS, payload };
}

export function createPrescriberFail(payload) {
  return { type: CREATE_PRESCRIBER_FAIL, payload };
}

export function updatePrescriber(payload) {
  return { type: UPDATE_PRESCRIBER, payload };
}

export function updatePrescriberSuccess(payload) {
  return { type: UPDATE_PRESCRIBER_SUCCESS, payload };
}

export function updatePrescriberFail(payload) {
  return { type: UPDATE_PRESCRIBER_FAIL, payload };
}

export function deletePrescriber(payload) {
  return { type: DELETE_PRESCRIBER, payload };
}

export function deletePrescriberSuccess(payload) {
  return { type: DELETE_PRESCRIBER_SUCCESS, payload };
}

export function deletePrescriberFail(payload) {
  return { type: DELETE_PRESCRIBER_FAIL, payload };
}

export function addPrescriberResource(payload) {
  return { type: ADD_PRESCRIBER_RESOURCE, payload };
}

export function addPrescriberResourceSuccess(payload) {
  return { type: ADD_PRESCRIBER_RESOURCE_SUCCESS, payload };
}

export function addPrescriberResourceFail(payload) {
  return { type: ADD_PRESCRIBER_RESOURCE_FAIL, payload };
}

export function removePrescriberResource(payload) {
  return { type: REMOVE_PRESCRIBER_RESOURCE, payload };
}

export function removePrescriberResourceSuccess(payload) {
  return { type: REMOVE_PRESCRIBER_RESOURCE_SUCCESS, payload };
}

export function removePrescriberResourceFail(payload) {
  return { type: REMOVE_PRESCRIBER_RESOURCE_FAIL, payload };
}

// Requests

let abort;

export function requestFetchPrescribers({ limit, offset }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi(`resource/prescriber/?limit=${limit}&offset=${offset}`);
  abort = request.abort;
  return request.res;
}

export function requestSearchPrescribers({ limit, offset, filters }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('resource/prescriber/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'First Name',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestCreatePrescriber(payload) {
  return callApi('resource/prescriber/', 'POST', payload);
}

export function requestUpdatePrescriber(payload) {
  return callApi('resource/prescriber/', 'PATCH', payload);
}

export function requestDeletePrescriber(payload) {
  return callApi(`resource/prescriber/?id=${payload}`, 'DELETE');
}

export function requestAddPrescriberResource(payload) {
  return callApi('resource/prescriber/change_resource/add/', 'POST', payload);
}

export function requestRemovePrescriberResource(payload) {
  return callApi('resource/prescriber/change_resource/remove/', 'POST', payload);
}

export function requestCreatePrescriberTaxonomy(payload) {
  return callApi('resource/taxonomies/', 'POST', payload);
}

// Sagas
function* fetchPrescribersSaga(action) {
  const { triggerLoading, filters } = action.payload;
  try {
    const res = filters
      ? yield call(requestSearchPrescribers, action.payload)
      : yield call(requestFetchPrescribers, action.payload);
    yield put(fetchPrescribersSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
      ...action.payload.push ? { push: true } : {},
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchPrescribersFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createPrescriberSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreatePrescriber, values);
    yield put(createPrescriberSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New prescriber successfully added',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    if (err.data && err.data.error
      && err.data.error === 'Unique check fail: object with same \'last_name\', \'first_name\', \'npi\' already exists') {
      const error = {
        error: 'Prescriber with identical Last Name, First Name and NPI already exist',
      };
      yield put(createPrescriberFail(error));
      if (reject) {
        reject(error);
      }
    } else {
      yield put(createPrescriberFail(err.data));
      if (reject) {
        reject(err.data);
      }
    }
  }
}

function* updatePrescriberSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdatePrescriber, values);
    yield put(updatePrescriberSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Prescriber successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    if (err.data && err.data.error
      && err.data.error === 'Unique check fail: object with same \'last_name\', \'first_name\', \'npi\' already exists') {
      const error = {
        error: 'Prescriber with identical Last Name, First Name and NPI already exist',
      };
      yield put(updatePrescriberFail(error));
      if (reject) {
        reject(error);
      }
    } else {
      yield put(updatePrescriberFail(err.data.error));
      if (reject) {
        reject(err.data);
      }
    }
  }
}

function* deletePrescriberSaga(action) {
  const { ID } = action.payload;
  try {
    const res = yield call(requestDeletePrescriber, ID);
    yield put(deletePrescriberSuccess({ ID }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Prescriber successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deletePrescriberFail(err.data));
    yield put(addNotification({
      message: 'Failed to delete prescriber',
      variant: 'warning',
    }));
  }
}

function* addPrescriberResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    let taxonomyRes;
    if (values['Taxonomies ID']) {
      taxonomyRes = yield all(
        values['Taxonomies ID'].map(item =>
          call(requestCreatePrescriberTaxonomy, {
            ...item,
            'Prescriber ID': values.ID,
          })),
      );
    }
    const res = yield call(requestAddPrescriberResource, {
      ID: values.ID,
      ...taxonomyRes ? { 'Taxonomies ID': taxonomyRes.map(item => item.data.ID) } : {},
      ...values['Referral Source ID'] ? { 'Referral Source ID': values['Referral Source ID'] } : {},
    });
    yield put(addPrescriberResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(addPrescriberResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* removePrescriberResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestRemovePrescriberResource, {
      ...values,
      ...values['Taxonomies ID'] ? { 'Taxonomies ID': values['Taxonomies ID'].map(item =>
        item.ID) } : {},
      ...values['Referral Source ID'] ? { 'Referral Source ID': values['Referral Source ID'] } : {},
    });
    yield put(removePrescriberResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(removePrescriberResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* prescribersSaga() {
  yield takeLatest(FETCH_PRESCRIBERS, fetchPrescribersSaga);
  yield takeEvery(CREATE_PRESCRIBER, createPrescriberSaga);
  yield takeEvery(UPDATE_PRESCRIBER, updatePrescriberSaga);
  yield takeEvery(DELETE_PRESCRIBER, deletePrescriberSaga);
  yield takeEvery(ADD_PRESCRIBER_RESOURCE, addPrescriberResourceSaga);
  yield takeEvery(REMOVE_PRESCRIBER_RESOURCE, removePrescriberResourceSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/prescribers.js